/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import No from './No/index'
import Paused from './Paused/index'
import React from 'react'
import Started from './Started/index'
import Stopped from './Stopped/index'
import TysiaIconDentalMonitoring from 'DesignSystem/Svgs/TysiaIconDentalMonitoring/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import Unstarted from './Unstarted/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let dentalMonitoringPatientMonitoringStatusValueData = fromData.useDataValue({ viewPath,
context: 'dental_monitoring',
path: 'patient.monitoring.status',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: dentalMonitoringPatientMonitoringStatusValueData,
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dentalMonitoringPatientLinksPublicProfileValueData = fromData.useDataValue({ viewPath,
context: 'dental_monitoring',
path: 'patient._links.public_profile',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconDentalMonitoring
  viewPath={`${viewPath}/TysiaIconDentalMonitoring`}
 width={16}
 height={16}
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 marginLeft={dtSpaceXs}
 data="dental_monitoring.patient._links.public_profile"
 goTo={dentalMonitoringPatientLinksPublicProfileValueData}
 text="View patient in DM"
/>
</div>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Unstarted'}>
<Unstarted
  viewPath={`${viewPath}/Unstarted`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Started'}>
<Started
  viewPath={`${viewPath}/Started`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Stopped'}>
<Stopped
  viewPath={`${viewPath}/Stopped`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Paused'}>
<Paused
  viewPath={`${viewPath}/Paused`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}